import { Wrapper } from './nav.styles';

import VendorLogo from '../../common/vendor_logo';
import Menu from './menu';
import RegisterBanner from './register_banner';

export default function Nav() {
  return (
    <Wrapper>
      <VendorLogo />
      <RegisterBanner />
      <Menu />
    </Wrapper>
  );
}
